import * as React from 'react'
import isEmpty from 'lodash.isempty'
import Help from '../../../../../components/Help'
import { GenericInput } from '../../../../../components/Inputs'
import { InputLabel } from '../../../../../components/inputs/InputLabel'
import { UprightStyle } from '../../../../../types'
import { templateStyles } from './templateStyles'

const styles: UprightStyle = {
  textAreaContainer: { height: '100%' }
}

export const Form = ({ input, onFormPreviewChange, index }) => {
  const { props } = input
  return (
    <div style={styles.textAreaContainer}>
      <InputLabel
        title={props.label}
        required={props.required && isEmpty(props.value)}
        style={styles.textAreaContainer}
        requiredLabelStyle={templateStyles.requiredLabel}
        requiredLabelIconName={props.requiredLabelIconName}
      >
        <textarea
          style={{ width: '100%', height: 'calc(100% - 25px)' }}
          className="bp5-input"
          value={props.value}
          placeholder={props.placeholder}
          onChange={e => onFormPreviewChange(index, e.target.value)}
        />
      </InputLabel>
      {props.helpText && (
        <Help>
          <div>{props.helpText}</div>
        </Help>
      )}
    </div>
  )
}

export const Configuration = ({ input, onChange }) => {
  const inputProps = input.props
  return (
    <div>
      <GenericInput title="Placeholder" value={inputProps.placeholder} onChange={v => onChange('placeholder', v)} />
    </div>
  )
}
